import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export default function VideoSection() {
  const { t } = useLanguage();

  return (
    <section className="py-20 md:py-28 bg-[#0A0A0A]" data-testid="video-section">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-xs uppercase tracking-[0.25em] text-[#FFD700] mb-4 font-light">
            {t.video.overline}
          </p>
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-light text-white tracking-tight">
            {t.video.title}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative border border-white/10 overflow-hidden bg-black flex items-center justify-center"
          data-testid="video-container"
        >
          <video
            className="w-full object-contain"
            style={{ maxHeight: "80vh" }}
            controls
            playsInline
            preload="metadata"
            data-testid="video-player"
          >
            <source src="/video.mp4" type="video/mp4" />
          </video>
        </motion.div>
      </div>
    </section>
  );
}
